import React from "react"

const Loading = () => {
    return <div className="d-flex justify-content-center">
            <div className="spinner-border" role="status" />
        </div>
}

export default Loading;